<div class="channels-tab">

    <div class="title">Channels</div>

    <form [formGroup]="formGroup">

        <div class="row channel-group">

            <div class="col-md-1 channel-icon-container">
                <i class="fa-regular fa-envelope fa-2x"></i>
            </div>

            <div class="col-md-10">

                <div class="row margin-top-5">
                    <div class="col-md-12">
                        <div class="font-bold margin-top-5">Email Notifications</div>
                        <div class="margin-top-5">Receive notifications via email.</div>
                    </div>
                </div>

                <!-- TODO: show this once we have a way to set the email frequency -->
                <div style="display: none;" class="row margin-top-36" *ngIf="localUserPreferences?.channelSetting?.email != false">
                    <div class="col-md-3">
                        <div>Email Frequency</div>
                    </div>

                    <div class="col-md-9">
                        <label class="btn-radio-container">
                            <input type="radio" [value]="emailFrequency.Individual"
                                formControlName="channelEmailFrequency"
                                (change)="onEmailFreqRadioChanged(emailFrequency.Individual)"><span></span>
                            Receive individual emails
                        </label>
                        <label class="btn-radio-container">
                            <input type="radio" [value]="emailFrequency.WeeklyDigest"
                                formControlName="channelEmailFrequency"
                                (change)="onEmailFreqRadioChanged(emailFrequency.WeeklyDigest)"><span></span>
                            Weekly digest
                        </label>
                        <label class="btn-radio-container">
                            <input type="radio" [value]="emailFrequency.MonthlyDigest"
                                formControlName="channelEmailFrequency"
                                (change)="onEmailFreqRadioChanged(emailFrequency.MonthlyDigest)"><span></span>
                            Monthly digest
                        </label>
                    </div>
                </div>

                <!-- <div class="row margin-top-24">
                    <div class="col-md-3">
                        <div style="margin-top: 12px;">Email Address</div>
                    </div>

                    <div class="col-md-4">
                        <input type="text" name="email" placeholder="Email" class="form-control" disabled="true">
                    </div>
                </div> -->

            </div>

            <div class="col-md-1">
                <dx-switch #emailChannelSwitch formControlName="emailChannelSwitch" [value]="true" [width]="50"
                    [switchedOnText]="''" [switchedOffText]="''"
                    (onValueChanged)="onEmailChannelSwitchChanged($event)">
                </dx-switch>
            </div>

        </div>

    </form>
</div>